import React, {useEffect, useState} from "react";
import {useLoad} from "../../context";
import ApiServices from "../../services/apiServices";
import "./index.css";

export default function Faq() {
  const {load, setLoad} = useLoad();
  const [faq, setFaq] = useState([]);
  const [termoPesquisa, setTermoPesquisa] = useState("");
  const [faqFiltrado, setFaqFiltrado] = useState([]);

  async function fnFaq() {
    try {
      setLoad(true);
      let response = await ApiServices.apiGet("faq/de-participante");
      setFaq(response.data);
      setFaqFiltrado(response.data.filter((e) => e.logado));
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    fnFaq();
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (termoPesquisa === "") {
      setFaqFiltrado(faq.filter((e) => e.logado));
    } else {
      const filtrado = faq.filter(
        (e) =>
          e.logado &&
          (e.titulo.toLowerCase().includes(termoPesquisa.toLowerCase()) ||
            e.texto.toLowerCase().includes(termoPesquisa.toLowerCase()))
      );
      setFaqFiltrado(filtrado);
    }
  }, [termoPesquisa, faq]);

  return (
    <>
      <div className="faq-container">
        <div className="faq-content">
          <h1 className="faq-title">Perguntas Frequentes</h1>
          
          <div className="faq-search-container">
            <input
              type="text"
              className="form-control faq-search-input"
              placeholder="Pesquisar no perguntas frequentes"
              value={termoPesquisa}
              onChange={(e) => setTermoPesquisa(e.target.value)}
            />
          </div>

          <div className="faq-accordion-container">
            {faqFiltrado.length === 0 ? (
              <div className="faq-empty-message">
                <p>Nenhuma pergunta encontrada.</p>
              </div>
            ) : (
              faqFiltrado.map((e, i) => (
                <div key={i} className="accordion accordion-flush" id={"accordionFlushExample" + i}>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id={"flush-headingOne" + i}>
                      <button
                        className="accordion-button collapsed tituloFaq"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={"#flush-collapseOne" + i}
                        aria-expanded="false"
                        aria-controls="flush-collapseOne">
                        {e.titulo.toUpperCase()}
                      </button>
                    </h2>
                    <div
                      id={"flush-collapseOne" + i}
                      className="accordion-collapse collapse textFaq"
                      aria-labelledby={"flush-headingOne" + i}
                      data-bs-parent={"#accordionFlushExample" + i}>
                      <div className="accordion-body" dangerouslySetInnerHTML={{__html: e.texto}} />
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
}
